import React from 'react';
import { Checkbox } from './checkbox';

// Shared, uniform privacy consent used by every public form collecting personal data.
export const PrivacyConsent = ({ checked, onChange, testId, noticeHref = '/compliance/privacy', note }) => {
  const id = `${testId}-input`;
  return (
    <div className="flex items-start space-x-3 p-4 rounded-lg bg-muted/30 border border-border">
      <Checkbox id={id} checked={checked} onCheckedChange={onChange} data-testid={testId} />
      <div className="grid gap-1.5 leading-none">
        <label htmlFor={id} className="text-sm font-medium leading-relaxed cursor-pointer">
          Ho letto e compreso l'
          <a
            href={noticeHref}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline"
            data-testid={`${testId}-link`}
          >
            informativa privacy
          </a>
          {' *'}
        </label>
        <p className="text-xs text-muted-foreground">
          {note || '* Campo obbligatorio per l\'invio del modulo'}
        </p>
      </div>
    </div>
  );
};

// Hidden field only bots fill in. Kept out of the tab order and hidden from screen readers.
export const HoneypotField = ({ value, onChange, idPrefix = 'hp' }) => (
  <div aria-hidden="true" style={{ position: 'absolute', left: '-9999px', width: 1, height: 1, overflow: 'hidden' }}>
    <label htmlFor={`${idPrefix}-website`}>Website</label>
    <input
      id={`${idPrefix}-website`}
      name="website"
      type="text"
      tabIndex={-1}
      autoComplete="off"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

export default PrivacyConsent;
